import HarisService from "../HarisService"


const Auth = {
    login(data) {
        return HarisService.postWithoutAuth('/api/auth/login', data)
    },
    me() {
        return HarisService.get("/api/auth/me")
    },
    getUser(userId) {
        return HarisService.get('/api/user/gets?ids=' + userId)
    },
    checkIndentity(type, value) {
        return HarisService.get('/api/user/check/' + type + '?value=' + value)
    }
}

export default Auth